(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfFixedHeader', [
    '$timeout', '$window', function($timeout, $window) {
      return {
        restrict: 'A',
        link: {
          pre: (function(_this) {
            return function($scope, $elem, $attrs, $ctrl) {
              return void 0;
            };
          })(this),
          post: (function(_this) {
            return function($scope, $elem, $attrs, $ctrl) {
              var fixIt;
              fixIt = function() {
                return $timeout(function() {
                  var scrollBarWidth, widths;
                  $elem.find('thead, tfoot, tbody').css('display', '');
                  $elem.find('th, td').css('width', '');
                  $elem.find('th, td').each(function(i, elem) {
                    return $(elem).data('mf-width', $(elem).width());
                  });
                  $elem.find('th, td').each(function(i, elem) {
                    $(elem).width($(elem).data('mf-width'));
                    return $(elem).data('mf-width', null);
                  });
                  $elem.find('thead').css({
                    display: 'block'
                  });
                  $elem.find('tfoot').css({
                    display: 'block'
                  });
                  $elem.find('tbody').css({
                    display: 'block',
                    overflow: 'auto'
                  });
                  if ($elem.find('tbody')[0].scrollHeight !== $elem.find('tbody')[0].clientHeight) {
                    scrollBarWidth = $elem.find('thead').width() - $elem.find('tbody')[0].clientWidth;
                    widths = [];
                    $elem.find('thead th:last-child, thead td:last-child').each(function(i, cell) {
                      return widths[i] = $(cell).width();
                    });
                    return $elem.find('thead th:last-child, thead td:last-child').each(function(i, cell) {
                      cell = $(cell);
                      return cell.width(widths[i] + scrollBarWidth);
                    });
                  }
                });
              };
              angular.element($window).bind('resize', debounce(fixIt));
              if ($attrs != null ? $attrs.mfFixedHeader : void 0) {
                return $scope.$watch($attrs.mfFixedHeader, fixIt);
              }
            };
          })(this)
        }
      };
    }
  ]);

}).call(this);
